module.exports = __webpack_public_path__ + "static/fav-6e166fdd2a8710e911a613d58b2bf94d.ico";